/**
 * Generate a list of every possible transform key.
 */
var transformPropOrder = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"];
/**
 * A quick lookup for transform props.
 */
var transformProps = new Set(transformPropOrder);
export { transformPropOrder, transformProps };